import React from 'react';
import classnames from 'classnames';
import { Wrapper, LeftWrapper, RightWrapper } from './styles';
import Container from '../Container';

var Content = function Content(_ref) {
  var Left = _ref.left,
      Right = _ref.right,
      constrainWidth = _ref.constrainWidth,
      disableGutter = _ref.disableGutter,
      className = _ref.className,
      _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'div' : _ref$component,
      children = _ref.children,
      style = _ref.style,
      animateIn = _ref.animateIn;
  var hasAsideContent = Left || Right;
  return /*#__PURE__*/React.createElement(Wrapper, {
    hasAsideContent: hasAsideContent,
    className: classnames(className, {
      animateIn: animateIn
    }),
    as: component,
    style: style
  }, hasAsideContent && /*#__PURE__*/React.createElement(LeftWrapper, null, Left && /*#__PURE__*/React.createElement(Left, null)), /*#__PURE__*/React.createElement(Container, {
    constrainWidth: constrainWidth,
    disableGutter: disableGutter
  }, children), hasAsideContent && /*#__PURE__*/React.createElement(RightWrapper, null, Right && /*#__PURE__*/React.createElement(Right, null)));
};

export default Content;